import { render, staticRenderFns } from "./TurnoverCorpCard.vue?vue&type=template&id=adc21030&"
import script from "./TurnoverCorpCard.vue?vue&type=script&lang=js&"
export * from "./TurnoverCorpCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports